import { createApi } from '@reduxjs/toolkit/query/react';
import { type Question } from '@strata/react-question-tree';

import { CLINICAL_POLICY_API_URL } from 'api/APIBase';
import { handleRTKQueryError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

export const clinicalPolicyApi = createApi({
    baseQuery: getBaseQuery(CLINICAL_POLICY_API_URL),
    reducerPath: 'clinicalPolicyApi',
    endpoints: (build) => ({
        getQuestionTree: build.query<
            Question[],
            {
                payerId: string;
                productServiceOid: string;
                diagnosisOid: string;
            }
        >({
            query: ({ payerId, productServiceOid, diagnosisOid }) => ({
                url: `${payerId}/policies/${productServiceOid}/${diagnosisOid}`,
            }),
            transformResponse: (response: { graph: string } | undefined) =>
                (JSON.parse(response?.graph ?? '{}') as { nodes: Question[] }).nodes,
            transformErrorResponse: handleRTKQueryError(
                'An error occurred retrieving clinical policy.',
            ),
        }),
        getDefaultQuestionTree: build.query<
            Question[],
            {
                payerId: string;
            }
        >({
            query: ({ payerId }) => ({
                url: `${payerId}/policies/default_questions`,
            }),
            transformResponse: (response: { graph: string } | undefined) =>
                (JSON.parse(response?.graph ?? '{}') as { nodes: Question[] }).nodes,
            transformErrorResponse: handleRTKQueryError(
                'An error occurred retrieving default clinical policy questions.',
            ),
        }),
    }),
});

export const { useGetQuestionTreeQuery, useGetDefaultQuestionTreeQuery } = clinicalPolicyApi;
